<div class="meet-content--main-column">
  @if (loadedEvent) {
    @if (multiAgeGroups && multiAgeGroups.length > 0) {
      <div class="btn-group me-2 mb-3" ngbDropdown role="group" aria-label="Choose a heat to view">
        <button type="button" class="btn btn-primary" ngbDropdownToggle>
          <strong>
            @if (event.multiAgeGroupTitle) {
              {{ event.multiAgeGroupTitle }}:
            } @else {
              Age Group:
            }
          </strong>
          {{ currentAgeGroup ? currentAgeGroup.ageGroup : '' }}
        </button>
        <div class="dropdown-menu" ngbDropdownMenu>
          @for (multiAgeGroup of multiAgeGroups; track multiAgeGroup.id) {
            <button ngbDropdownItem (click)="refreshResults(multiAgeGroup)">
              {{ multiAgeGroup.ageGroup }}
            </button>
          }
        </div>
      </div>
    }

    @if (pageNames.length > 0) {
      <div class="btn-group me-2 mb-3" ngbDropdown role="group" aria-label="Choose a page of results to view">
        <button type="button" class="btn btn-secondary" ngbDropdownToggle>
          {{ pageNames[currentPage] }}
        </button>
        <div class="dropdown-menu" ngbDropdownMenu>
          @for (name of pageNames; track $index) {
            <button ngbDropdownItem (click)="changePage($index)">
              {{ name }}
            </button>
          }
        </div>
      </div>
    }

    @if (round) {
      @if (round === 'finals') {
        <a
          class="btn mb-3 me-2 btn-outline-secondary"
          [routerLink]="['/meets', event.meetId, 'events', 'individual', event.roundFinalAliveId]"
        >
          View the full Finals event<fa-icon class="ms-2" [icon]="['fas', 'chevron-right']"></fa-icon>
        </a>
      } @else if (round === 'semis') {
        <a
          class="btn mb-3 me-2 btn-outline-secondary"
          [routerLink]="['/meets', event.meetId, 'events', 'individual', event.roundSemiAliveId]"
        >
          View the full Semi Finals event
        </a>
      } @else if (round === 'qtrs') {
        <a
          class="btn mb-3 me-2 btn-outline-secondary"
          [routerLink]="['/meets', event.meetId, 'events', 'individual', event.roundQuarterAliveId]"
        >
          View the full Quarter Finals event
        </a>
      } @else if (round === 'prelims') {
        <a
          class="btn mb-3 me-2 btn-outline-secondary"
          [routerLink]="['/meets', event.meetId, 'events', 'individual', event.roundPrelimAliveId]"
        >
          View the full Prelims event
        </a>
      }
    }

    @if (heatNumbers.length > 1) {
      <div class="btn-group me-2 mb-3" ngbDropdown role="group" aria-label="Choose a heat to view">
        <button type="button" class="btn btn-secondary" ngbDropdownToggle>
          <strong>View:</strong> {{ heat ? typeWord + ' ' + heat : 'All Results' }}
        </button>
        <div class="dropdown-menu" ngbDropdownMenu>
          <button ngbDropdownItem (click)="processResults()">All Results</button>
          @for (heat of heatNumbers; track $index) {
            <button ngbDropdownItem (click)="processResults(heat)">{{ typeWord }} {{ heat }}</button>
          }
        </div>
      </div>
    }
    @if (loadedResults) {
      @if (
        pageIndResultLists &&
        pageIndResultLists.length > currentPage &&
        pageIndResultLists[currentPage] &&
        pageIndResultLists[currentPage].individualResults
      ) {
        <div class="dynamic--results-table results-table--grid mb-3">
          @for (result of pageIndResultLists[currentPage].individualResults; track result.id) {
            <div
              class="results-table--row"
              [ngClass]="{ 'results-table--row--show-thumbnail': showThumbnail }"
              (click)="openModal(result, pageIndResultLists[currentPage])"
              role="button"
            >
              <div class="results-table--container--top">
                <div class="results-table--place results-table--id__primary">
                  {{ result.place }}
                </div>
                <app-results-grid-row
                  [firstName]="result.athlete.firstName"
                  [lastName]="result.athlete.lastName"
                  [teamName]="result.athlete.team.fullName"
                  [teamLogoSrc]="result.athlete.team.logo"
                  [profilePicSrc]="result.athlete.photoUrl"
                  [secondaryResult]="result"
                  [secondaryValue]="result.mark"
                  [tertiaryResult]="result"
                  [showHeat]="true"
                  [primaryEventGroup]="event.primaryEventGroup"
                ></app-results-grid-row>
                @if (result.imageThumbnail) {
                  <div class="results-table--cell results-table--thumbnail">
                    <img class="result-thumbnail" [ngSrc]="result.imageThumbnail" fill />
                    @if (result.imageThumbnailIsVideo) {
                      <fa-icon
                        class="fa fa-video result-thumbnail--video-overlay"
                        [icon]="environment.icons.video"
                      ></fa-icon>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
        @if (event && event.updatedAt) {
          <p class="alert alert--event alert--event-notes">
            <app-event-updated-at [dataPointType]="'result'" [date]="event.updatedAt"></app-event-updated-at>
          </p>
        }
      } @else {
        <p i18n="No results available currently message@results.noResultsAvailable">
          No results available at this time. Please check again soon.
        </p>
      }
    } @else {
      <div>
        <fa-icon [icon]="environment.icons.spinner" [fixedWidth]="true" animation="spin"></fa-icon>
        &nbsp;
        <span i18n="Loading Results loader@@results.loading">Loading Live Data</span>
      </div>
    }
    @if (pageNames.length > 0) {
      <div class="btn-group me-2 mt-3" ngbDropdown role="group" aria-label="Choose a page of results to view">
        <button type="button" class="btn btn-secondary" ngbDropdownToggle>
          {{ pageNames[currentPage] }}
        </button>
        <div class="dropdown-menu" ngbDropdownMenu>
          @for (name of pageNames; track $index) {
            <button ngbDropdownItem (click)="changePage($index)">
              {{ name }}
            </button>
          }
        </div>
      </div>
    }
  } @else {
    <fa-icon [icon]="environment.icons.spinner" [fixedWidth]="true" animation="spin"></fa-icon>
    &nbsp;
    <span i18n="Loading Event loader@@results.loadingEvent">Loading Event</span>
  }
</div>
